import { useMemo } from 'react';
import { Contribution, Operation, Partner } from 'types';

type UseGetContributionDataForPartnerProps = {
  contributionOperation: Operation | undefined;
  partner: Partner;
};

const extractOldContributionData = (operation: Operation, partner: Partner) => {
  const contribution = operation?.contributions?.find(
    (contribution) =>
      ((contribution as Contribution).partner as Partner)?._id === partner._id
  ) as Contribution | undefined;

  return {
    ndPercentage: contribution?.percent ?? 0,
    amount: contribution?.amount ?? 0,
  };
};

const extractNewDividendData = (operation: Operation, partner: Partner) => {
  const contribution = partner?.contributions.find(
    (contribution) => contribution.operation === operation._id
  );

  return {
    ndPercentage: contribution?.ndPercentage || 0,
    amount: contribution?.amount || 0,
  };
};

export const useGetContributionDataForPartner = ({
  contributionOperation,
  partner,
}: UseGetContributionDataForPartnerProps) => {
  const data = useMemo(() => {
    if (!contributionOperation) {
      return {
        ndPercentage: 0,
        amount: 0,
      };
    }
    const hasOldContributions = !!contributionOperation?.contributions?.length;

    return hasOldContributions
      ? extractOldContributionData(contributionOperation, partner)
      : extractNewDividendData(contributionOperation, partner);
  }, [contributionOperation, partner]);

  return { data };
};
